export const countryConfigAM = {
  home: {
    skeleton: {
      banner: false,
      bubbles: true,
      featuredProducts: true,
      services: true,
      starredProductLists: 0,
      starredCards1: false,
      starredCards2: false,
      posts: false
    }
  }
};
